import config from "../assets/config";
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
import Mustache from "mustache";

export const common = {
  computed: {
    ...mapGetters([
      "user_logged",
      "getStateCookie",
      "getStateData",
      "getActualPage",
      "getTargets",
      "getEspacioDisponible",
      "getCuentasDisponibles",
    ]),
    dispositivo() {
      return this.$store.getters.getStateData("pantalla_dispositivo");
    },
    user_entidad_id() {
      let user = this.getStateData("user");
      let entidad = user ? user.entity : undefined;
      return entidad ? entidad.docnumber : null;
    },
    user_rol() {
      let user = this.getStateData("user");
      user = user || { rol: "invitado" };
      return user.rol;
    },
    user_entidad_name() {
      let user = this.getStateData("user");
      let entidad = user ? user.entity : undefined;
      return entidad ? entidad.name : null;
    },
  },
  watch: {
    dispositivo() {
      this.$forceUpdate();
    },
  },
  methods: {
    ...mapMutations([
      "messageError",
      "messageToast",
      "setStateCookie",
      "setStateData",
      "setEspacioDisponible",
      "setCuentasDisponibles",
    ]),
    getHeadersForTable(plantilla, initialHeaders) {
      let lang = this.$i18n.locale;
      let labelKey = lang == "es" ? `label` : `label_${lang}`;
      let campos = [];
      plantilla.forEach((x) => {
        if (x.type == "stepper") {
          x.children.forEach((step) => {
            step.children.forEach((stepField) => {
              if (stepField.headers != false && stepField.headers != "false")
                campos.push(stepField);
            });
          });
        } else {
          if (x.headers != false && x.headers != "false") campos.push(x);
        }
      });

      let headers = campos
        .map((x) => {
          let name = x.headers ? x.headers : x.name;
          if (name === true || name === "true") name = x.name;
          return {
            element: x,
            text: x.label_report ? x.label_report : x[labelKey],
            value: name,
            type: x.type,
            format: x.format,
            type_aux: x.type_aux,
            orderList: x.orderList ? x.orderList : 100,
          };
        })
        .sort((a, b) => {
          if (a.orderList > b.orderList) return 1;
          if (a.orderList < b.orderList) return -1;
          return 0;
        });

      return initialHeaders ? initialHeaders.concat(headers) : headers;
    },
    getOptions() {
      let headers = this.$store.getters.getHeader;
      return { headers };
    },

    getHeaders() {
      let headers = this.$store.getters.getHeader;
      return headers;
    },

    obtenerFecha(formato) {
      return formato ? this.$moment().format(formato) : this.$moment().format();
    },
    fechaActual() {
      return this.$moment().format();
    },

    obtenerDiasEntreDosFechas(fechaMenor, fechaMayor) {
      var fecha1 = moment(fechaMenor);
      var fecha2 = fechaMayor ? moment(fechaMayor) : moment();

      return fecha2.diff(fecha1, "days"); // true
    },

    fechaVencida(fecha) {
      if (fecha) {
        return moment().isSameOrAfter(fecha); // true
      } else {
        return false;
      }
    },

    async getPlantilla(plantilla, actualizarPagina = true) {
      try {
        if (!plantilla) {
          this.$router.push(config.router.home);
        }
        let url = config.api.plantillas + plantilla;
        let response = await this.$axios.get(url);
        let result = response.data;
        if (result && result.info.template) {
          let tmp = result.info.template;
          if (actualizarPagina) {
            this.setStateData({ key: "page", value: tmp.title });
          }
          return tmp;
        }
      } catch (error) {
        console.error(error);
        // this.$router.push(config.router.home);
      }
    },

    getAllData(id, filter, search) {
      this.items = [];
      let url = config.api.url + this.path;
      if (id) url += id;
      if (filter) url += filter;
      if (this.pagination) {
        let pag = Object.assign({}, this.pagination);
        url += pag.page ? (filter ? `&page=${pag.page}` : `?page=${pag.page}`) : "";
        url += pag.rowsPerPage ? `&limit=${pag.rowsPerPage}` : "";
        url += pag.sortBy ? `&sortby=${pag.sortBy}` : "";
        url += pag.descending ? `&descending=${pag.descending}` : "";
        url += search && search.length > 0 ? `&search=${search}` : "";
      }
      this.loading = true;
      this.error = false;
      this.$axios
        .get(url)
        .then((response) => {
          let result = response.data;
          if (result != undefined) {
            if (Array.isArray(result.info)) {
              this.items = result.info.map((x) => {
                if (x.doc) {
                  let data = Object.assign({}, x.doc, x);
                  delete data.doc;
                  return data;
                } else {
                  return x;
                }
              });
              this.metaInfo = result.metainfo;
              localStorage.setItem(
                config.cookie.filters_cases_data,
                JSON.stringify(result.metainfo.columnasFiltros)
              );
              this.totalItems = result.metainfo.total
                ? parseInt(result.metainfo.total)
                : 0;
            } else this.items = [];
          }
        })
        .catch((error) => {
          console.error(error);
          this.error = true;
          this.messageError(error);
        })
        .then(() => {
          this.loading = false;
        });
    },

    /**
     * Consulta los registros "Externals" de un
     * header y los retorna en una lista.
     * @param {*} headers
     */
    getAllExternals(headers) {
      this.externals = [];
      // Objeto externo
      let external = {
        name: String,
        text: String,
        data: Array,
      };
      headers.forEach((header) => {
        if (header.type == "select_multiple_external") {
          let url = config.api.url + header.element.external_url;
          this.$axios
            .get(url)
            .then((response) => {
              let result = response.data;
              if (result != undefined) {
                if (Array.isArray(result.info)) {
                  external.name = header.value;
                  external.text = header.text;
                  external.data = result.info;
                  this.externals.push(external);
                }
              }
            })
            .catch((error) => {
              console.error(error);
              this.error = true;
              this.messageError(error);
            });
        }
      });
    },

    async mxGetAllDataAsync(url) {
      let response = await this.$axios.get(url);
      let result = response.data;
      if (result.success) return result.info;
      else[];
    },

    async fetchBoardsByGroup(group) {
      let options = this.getOptions();
      let token = options.headers.token;
      try {
        const response = await this.$axios.get(
          `${config.api.url}/form_board`
        );
        
        const groupBoards = response.data.info.filter(
          board => board.doc && board.doc.group === group
        );
        
        const boardsPromises = groupBoards.map(async (board) => {
          try {
            const response = await this.$axios.get(
              `${config.api.url}/data/${board.doc.source}?token=${token}&f=json`
            );
            return {
              ...board,
              data: response.data,
              error: false,
              errorMessage: null
            };
          } catch (error) {
            return {
              ...board,
              data: null,
              error: true,
              errorMessage: `Error loading board: ${board.doc.name}`
            };
          }
        });
        
        const boardsResponses = await Promise.all(boardsPromises);
        
        return boardsResponses;
      } catch (error) {
        return [];
      }
    },

    async initParadocs(table, template) {
      let url = `${config.api.paradocs}${table}new/${template}`;
      let response = await this.$axios.get(url);
      let result = response.data;
      if (result.success) return result.info;
      else[];
    },

    async saveParadocs(table, data) {
      let url = `${config.api.paradocs}${table}${data.docId}`;
      let response = await this.$axios.put(url, data);
      return response.data;
    },

    async getParadocs(table, docid) {
      let url = `${config.api.paradocs}${table}${docid}`;
      let response = await this.$axios.get(url);
      return response.data;
    },

    async deleteParadocs(table, docId) {
      let url = `${config.api.paradocs}${table}${docId}`;
      let response = await this.$axios.delete(url);
      return response.data;
    },

    async initParacodes(table, template) {
      let url = `${config.api.paracodes}${table}new/${template}`;
      let response = await this.$axios.get(url);
      let result = response.data;
      if (result.success) return result.info;
      else[];
    },

    async saveParacodes(table, data) {
      let url = `${config.api.paracodes}${table}${data.codeId}`;
      let response = await this.$axios.put(url, data);
      return response.data;
    },

    async getParacodes(table, docid) {
      let url = `${config.api.paracodes}${table}${docid}`;
      let response = await this.$axios.get(url);
      return response.data;
    },

    async mxSearchCaseById(path, field, value) {
      let url = `${config.api.url}${path}?wf_casos.doc__${field}=${value}`;
      let response = await this.$axios.get(url);
      return response.data;
    },

    async deleteParacodes(table, docId) {
      let url = `${config.api.paracodes}${table}${docId}`;
      let response = await this.$axios.delete(url);
      return response.data;
    },
    /**
     * Muestra un modal con la información del error.
     * @param {Object} detalle El detalle es la información del error, muestra título más un mensaje conformado por `subtitulo, donde y que_hago`:
     * - donde Mensaje donde ocurre el error.
     * - titulo=[Error] Título del error.
     * - subtitulo=[Ha ocurrido un problema] Subtítulo del error.
     * - que_hago=[Recargar la página] Mensaje de solución.
     *
     * El mensaje siempre finaliza con  `si el error persiste por favor contactar a sistemas`.
     * @param {string} detalle.donde Mensaje donde ocurre el error.
     * @param {string} [detalle.titulo=Error] Título del error.
     * @param {string} [detalle.subtitulo=Ha ocurrido un problema] Subtítulo del error.
     * @param {string} [detalle.que_hago=Recargar la página] Mensaje de solución.
     * @param {Error=} error Error de respuesta del API, sobrescribe el subtítulo.
     */
    sweetError(detalle, error) {
      let titulo = detalle.titulo ? detalle.titulo : this.$t("sms.error");
      let subtitulo = detalle.subtitulo ? detalle.subtitulo : this.$t("sms.errorTitle");
      let donde = detalle.donde;
      let que_hago = detalle.que_hago ? detalle.que_hago : "";
      if (error) {
        subtitulo += ` (${error})`;
        if (error.response) {
          let data = error.response.data;
          subtitulo = data.message || subtitulo;
          if (data.info && data.info.code == "23505") {
            que_hago = "Cambiar la información del formulario";
          }
        }
      }
      this.$swal.fire(
        titulo,
        `${subtitulo} ${donde} ${que_hago}, ${this.$t("sms.errorSoluction")}`,
        "error"
      );
    },

    sweet(detalle) {
      let titulo = detalle.titulo ? detalle.titulo : this.$t("sms.success");
      let subtitulo = detalle.subtitulo ? detalle.subtitulo : "Operation successful.";
      this.$swal.fire(titulo, `${subtitulo}`, "success");
    },
    sweetWarning(mensaje) {
      let titulo = this.$t("sms.warning");
      this.$swal.fire(titulo, mensaje, "warning");
    },

    abrirArchivo(data, item) {
      let headers = this.$store.getters.getHeader;
      let archivo = "";
      if (data && typeof data == "string") {
        if (data.includes("http")) {
          archivo = data;
          let temp = data.split("/");
          let nameFile = temp[temp.length - 1];
          archivo = `${nameFile}`;
        } else {
          archivo = `${data}`;
        }
      } else if (data && typeof data == "object") {
        archivo = `${data.info}`;
      }
      let ruta = `${config.api_no_proxy.archivos}${this.$store.getters.proyecto_v.codenumber}/`;
      if (item && item.public) ruta += "public/";

      let query = `?token=${headers.token}`;
      window.open(ruta + archivo + query);
    },
    abrirReporte(url) {
      try {
        var link = document.createElement("a");
        link.href = url;
        link.target = "blank";
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        this.sweetError({
          error,
          que_hago: "Haga click de nuevo en el botón de descargar",
        });
      }
    },

    // Restricciones por el plan
    getEspacio() {
      return parseFloat(this.$store.getters.getEspacioDisponible) > 0 ? true : false;
    },
    getCuentas() {
      return parseInt(this.$store.getters.getCuentasDisponibles) > 0 ? true : false;
    },
    getPlan() {
      return this.$store.getters.getPlanContratado;
    },

    verLandingPage(item, plantilla) {
      let url =
        config.api_no_proxy.landing +
        `${this.user_entidad_id}/${plantilla.name}/${item.codeId}`;
      window.open(url);
    },

    /**
     * Renderiza un template y le aplica el eval de javascript
     * @param {*} template
     * @param {*} data
     */
    mustacheAndEval(template, data) {
      try {
        let show = Mustache.render(template, data);
        
        // Verificar y corregir literales octales problemáticos
        // Reemplazar números que empiecen con 0 seguidos de dígitos (excepto 0x para hex)
        // pero mantener 0 solo, 0.decimales, y 0x para hexadecimales
        let cleanShow = show.replace(/\b0+(\d+)\b/g, (match, digits) => {
          // Si es solo ceros seguidos de dígitos, convertir a decimal
          if (digits && /^\d+$/.test(digits)) {
            return parseInt(digits, 10).toString();
          }
          return match;
        });
        
        let evaluation = eval(cleanShow);
        return evaluation;
      } catch (error) {
        console.error('Error en mustacheAndEval:', error);
        console.error('Template original:', template);
        console.error('Datos:', data);
        
        // Si hay error, intentar devolver el template renderizado sin eval
        try {
          return Mustache.render(template, data);
        } catch (renderError) {
          console.error('Error en renderizado Mustache:', renderError);
          return template;
        }
      }
    },
    renderMustache(template, data) {
      let show = Mustache.render(template, data);
      return show;
    },
    tieneMustache(text) {
      return text && text.toString().includes("{{") && text.toString().includes("}}");
    },
  },
};
